import FeedbackPage from '@/components/FeedbackPage'
import { LightBulbIcon } from '@heroicons/react/24/outline'

export default function BrainHealthIntroPage() {
  return (
    <FeedbackPage
      icon={<LightBulbIcon className="h-8 w-8 text-white" />}
      headingKey="pages.onboarding.brainHealthIntro.heading"
      descriptionKey="pages.onboarding.brainHealthIntro.description"
    />
  )
}
